
    import {defineComponent} from 'vue';
    import Board from './components/board.vue';
    import Score from './components/score.vue';

    export default defineComponent({
        components: {
            Board,
            Score
        },
    })
